import { render } from "./Section-8.vue?vue&type=template&id=4006b61a&scoped=true"
import script from "./Section-8.vue?vue&type=script&lang=js"
export * from "./Section-8.vue?vue&type=script&lang=js"

import "./Section-8.vue?vue&type=style&index=0&id=4006b61a&scoped=true&lang=css"

import exportComponent from "C:\\Spinnov\\ace-challenge-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4006b61a"]])

export default __exports__